module.exports = __webpack_public_path__ + "static/media/cert6.dd8507ae.png";